<template>

  <header class="app-header">

    <HeaderNav/>

    <!-- دکمهٔ منوی موبایل — کشوی کنار رو باز می‌کند -->
    <button
        class="mobile-menu-btn"
        type="button"
        aria-label="باز کردن منو"
        @click="drawer = true"
    >
      <span class="bar"></span>
      <span class="bar"></span>
      <span class="bar"></span>
    </button>

    <MobileDrawer
        :open="drawer"
        @close="drawer = false"
    />

  </header>

</template>

<script>

import HeaderNav from "./HeaderNav.vue";
import MobileDrawer from "./MobileDrawer.vue";

export default {

  name: "AppHeader",

  data() {
    return {
      drawer: false
    }
  },

  components: {
    HeaderNav,
    MobileDrawer
  }

}

</script>

<style scoped>

.app-header {
  display: flex;
  width: 100%;
  min-height: 80px;
  justify-content: center;
  align-items: center;

  position: sticky;
  top: 0;
  z-index: 1000;

  background: #081c15;
  padding: 0 30px;
}

.mobile-menu-btn {
  display: none;

  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);

  flex-direction: column;
  justify-content: center;
  gap: 4px;

  background: transparent;
  border: none;

  cursor: pointer;

  padding: 8px;

  .bar {
    display: block;
    width: 20px;
    height: 2px;
    border-radius: 2px;
    background: #fff;
  }
}

@media (max-width: 767px) {

  .app-header {
    min-height: 64px;
    height: 64px;
    padding: 0 14px;

    justify-content: space-between;
  }

  .mobile-menu-btn {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 44px;
    height: 44px;
  }

}

@media (min-width: 768px) {

  .mobile-menu-btn {
    display: none;
  }

}

</style>